import { css } from '@emotion/css';
import { LoadingSpinner as PJLoadingSpinner } from '@peachjar/ui/dist/lib/components/Spinners/Spinners';

type LoadingSpinnerProps = {
  height?: string;
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  height = '180px',
}) => (
  <div
    role="status"
    aria-live="polite"
    className={styles.container}
  >
    <span aria-hidden="true">
      <PJLoadingSpinner height={height} />
    </span>
    <span className="sr-only">Loading... Please wait.</span>
  </div>
);

const styles = {
  container: css`
    display: flex;
    align-items: center;
    justify-content: center ;
  `,
}
